import { createSlice } from '@reduxjs/toolkit';
import { getLegacyPatentes } from '../legacy/thunk.js';

export const initialState = {
    legacyPatentes: [],
    loading: false,
    error: {},
};

const legacyPatentesSlice = createSlice({
    name: 'legacyPatentes',
    initialState,
    reducers: {
        resetLegacyPatentes: (state) => {
            state.legacyPatentes = [];
            state.loading = false;
            state.error = {};
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getLegacyPatentes.fulfilled, (state, action) => {
            state.legacyPatentes = action.payload;
            state.loading = false;
        });
        builder.addCase(getLegacyPatentes.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = false;
        });
        builder.addCase(getLegacyPatentes.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyPatentesSlice.reducer;
export const { resetLegacyPatentes } = legacyPatentesSlice.actions;